import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, PropSync, Watch } from "vue-property-decorator";
import { eachDay, endOfWeek, format, getISODay, startOfWeek } from "date-fns";
let ScheduleBoard = class ScheduleBoard extends Vue {
    constructor() {
        super(...arguments);
        this.daysOffOptions = [];
    }
    created() {
        const date = new Date();
        const start = startOfWeek(date, { weekStartsOn: 1 });
        const end = endOfWeek(date, { weekStartsOn: 1 });
        eachDay(start, end).forEach(date => {
            this.daysOffOptions.push({
                text: format(date, 'dddd'),
                value: getISODay(date)
            });
        });
    }
    onUpdateDaysOffValue() {
        this.emitUpdateDaysOff();
    }
    emitUpdateDaysOff() {
    }
    get checkboxesId() {
        return `schedule-board-${this.boardId}`;
    }
    get checkboxesName() {
        return `schedule-board-${this.boardId}`;
    }
};
__decorate([
    Prop({ type: Number, required: true })
], ScheduleBoard.prototype, "boardId", void 0);
__decorate([
    Prop({ type: Number, required: true })
], ScheduleBoard.prototype, "boardName", void 0);
__decorate([
    PropSync('daysOff', { type: Array, required: true })
], ScheduleBoard.prototype, "daysOffValue", void 0);
__decorate([
    Watch('daysOffValue')
], ScheduleBoard.prototype, "onUpdateDaysOffValue", null);
__decorate([
    Emit('updateDaysOff')
], ScheduleBoard.prototype, "emitUpdateDaysOff", null);
ScheduleBoard = __decorate([
    Component({})
], ScheduleBoard);
export default ScheduleBoard;
